import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StarRating } from "@/components/StarRating";

export const ReviewsMarquee = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api
      .get("/reviews")
      .then((r) => setReviews(r.data))
      .catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  // duplicate for seamless loop
  const loop = [...reviews, ...reviews];

  return (
    <section
      data-testid="reviews-marquee"
      className="relative z-10 py-16 sm:py-20 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 text-center mb-10">
        <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-cyan-400 font-semibold">
          <span className="w-6 h-px bg-cyan-400/60" /> What the community says
        </span>
        <h2 className="font-heading font-extrabold tracking-tight mt-4 text-2xl sm:text-3xl text-gradient-chrome">
          Trusted by creators on-chain
        </h2>
      </div>

      <div className="relative">
        <div className="flex gap-5 w-max animate-marquee hover:[animation-play-state:paused]">
          {loop.map((r, i) => (
            <div
              key={`${r.id}-${i}`}
              data-testid="marquee-card"
              className="electric-card w-[320px] shrink-0 rounded-2xl bg-black/50 backdrop-blur-xl border border-white/10 p-6"
            >
              <p className="text-sm text-slate-300 leading-relaxed min-h-[96px]">"{r.comment}"</p>
              <div className="mt-4 pt-4 border-t border-white/10">
                <p className="font-heading font-bold text-white text-sm">{r.name}</p>
                <StarRating value={r.rating} className="mt-1.5" />
              </div>
            </div>
          ))}
        </div>
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black to-transparent" />
      </div>
    </section>
  );
};
